<template>
    <div>
            <CustomDialog ref='visiondialog' :element='devDialog.element' :styles='devDialog.styles' >
                <template v-slot:dialog-content>
                    <VersionPatchTask ref="verPatchTask" @close='cancel' :showToast='showToast'></VersionPatchTask>
                </template>
            </CustomDialog>
            <div class='h-toolbarBg'>
                <ejs-toolbar>
                    <e-items>
                        <e-item  prefixIcon='icon hero-icon hero-icon-add' :tooltipText='$t("Software.addtask")' :click='click' ></e-item>
                        <e-item  prefixIcon='icon hero-icon hero-icon-remove' :tooltipText='$t("Software.delete")' :click='remove' ></e-item>
                        <e-item  prefixIcon='icon hero-icon hero-icon-export' :tooltipText='$t("Alarm.exportAll")' :click='exportLog' ></e-item>
                    </e-items>
                </ejs-toolbar>
                <div class='h-inputBox'>
                    <ejs-textbox  :placeholder='$t("Software.keySerach")' @keydown.enter.native="search" v-model='input' />
                </div>
            </div>
            <div>
                <ejs-treegrid ref='grid' :dataSource='data' childMapping="subtasks" :allowResizing='true'
                    :rowDataBound="rowDataBound" autoCheckHierarchy="true" collapsed="true" height='calc(100vh - 236px)'>
                    <e-columns>
                        <e-column field='netCode' :headerText='$t("Software.td_neID")' width='6%' showCheckbox="true" clipMode='EllipsisWithTooltip'></e-column>
                        <e-column field='netType' :headerText='$t("Software.td_neName")' width='6%' clipMode='EllipsisWithTooltip'></e-column>
                        <e-column field='fileName' :headerText='$t("Software.td_fileName")' width='22%' clipMode='EllipsisWithTooltip'></e-column>
                        <e-column field='result' :headerText='$t("Software.td_result")' width='7%' :valueAccessor='resultFormatter' clipMode='EllipsisWithTooltip'></e-column>
                        <e-column field='createTime' :headerText='$t("Software.td_createTime")' width='11%' clipMode='EllipsisWithTooltip'></e-column>
                        <e-column field='taskId' :isPrimaryKey='true' :visible='false' ></e-column>
                    </e-columns>
                </ejs-treegrid>
                <ejs-pager ref='pagerPatch' @click='request' :currentPage='page.pageNo' :pageSize='page.pageSize' :totalRecordsCount='page.totalCount' :pageCount='page.pageCount'></ejs-pager>
            </div>
    </div>
</template>

<script>
import Vue from "vue";
import BasicLayout from '../../layouts/BasicLayout';
import { TreeGridPlugin, Page, Resize } from "@syncfusion/ej2-vue-treegrid";
import CustomDialog from '../../components/common/CustomDialog';
import VersionPatchTask from '../../components/software/VersionPatchTask';
import socketInstance from '../../plugins/stompSock';

import { EventBus } from '../../plugins/eventBus';

Vue.use(TreeGridPlugin);
let dataSource = [];
export default {
    name: 'version-patch',
    components:{
        BasicLayout,
        CustomDialog,
        VersionPatchTask,
    },
    data() {
        return{
            left: { show: false, name: '' },
            middle: { show: false, name: '' },
            right: { show: true, crumb: this.$t('Software.softManage_patch')},
            devDialog: {
                element: {
                    target: '#app',
                    isClose: true,
                    title: this.$t('Software.lte_patch_version'),
                    refName: this.$t('Software.updManage'),
                    buttonGroup: [
                        { click: this.cancel, buttonModel: { content: this.$t('MCS.cancle') } },
                        { click: this.submit, buttonModel: { content: this.$t('System.confirm'), isPrimary: true } },
                    ]
                },
                styles: {
                    width: "65%",
                    height: "80%",
                    visible: false,
                    model: true,
                    zIndex: 1001

                },
            },
            data: [],
            page: {
                pageNo: 1,
                pageSize: 15,
                totalCount: 0,
                pageCount: 4
            },
            pageSettings: { pageSizes: true, pageCount: 4, pageSize: 20 },
            input: '',
            resultmap: new Map(
                [
                    [0,this.$t('Software.success')],
                    [1,this.$t('Software.fail')],
                    [2,this.$t('Software.partSucc')],
                ]),
            payload: [
                { topic: '/topic/VmUpdateWsServer', clientId: '', callback: this.subscribeCallback }
            ],
        }
    },
    provide: {
      treegrid: [ Page, Resize],
    },
    mounted() {
        this.request();
        // socketInstance.init(this.payload);//与查询版本重冲突
    },
    beforeDestroy() {
        // for (let i = 0; i < this.payload.length; i++) {
        //     socketInstance.stopReceiveTopicMsg(this.payload[i].clientId, this.payload[i].topic);
        // }//与查询版本重冲突
    },
    methods: {
        request() {
            let page={
                    pageNo: this.$refs.pagerPatch.ej2Instances.currentPage,
                    pageSize: this.$refs.pagerPatch.ej2Instances.pageSize,
            };
            this.axios.post(`/lte/ems/verupdate_new/queryUpdatePatchTask?pageNo=${page.pageNo}&pageSize=${page.pageSize}&neName=${this.input}`).then((response) => {
                if(response.data.errorCode == 'SUCCESS'){
                    dataSource = response.data.resultVal.result;
                    this.page.totalCount = response.data.resultVal.totalCount;
                    this.page.pageNo = response.data.resultVal.pageNo;
                    this.page.pageSize = response.data.resultVal.pageSize,
                    this.page.pageCount = response.data.resultVal.totalPages === 0 ? 1: response.data.resultVal.totalPages;
                    this.dataBinding(dataSource);
                }
            });
        },
        webSoketRequest()
        {
            const that =this;
            let page={
                    pageNo: that.$refs.pagerPatch.ej2Instances.currentPage,
                    pageSize: that.$refs.pagerPatch.ej2Instances.pageSize,
            };
            that.axios.post(`/lte/ems/verupdate_new/queryUpdatePatchTask?pageNo=${page.pageNo}&pageSize=${page.pageSize}&neName=${that.input}`).then((response) => {
                if(response.data.errorCode == 'SUCCESS'){
                    if(that.data.length !== response.data.resultVal.totalCount)
                    {
                        console.log('request');
                        that.request();
                        return;
                    }
                    dataSource = response.data.resultVal.result;
                    let newdata = JSON.parse(JSON.stringify(that.data));
                    newdata.forEach(item => {
                        dataSource.forEach(element =>{
                            if(item.taskId == element.taskId)
                            {
                                that.$refs.grid.setCellValue(item.taskId, 'result',element.result);
                            }
                            else if(item.taskId == element._parentId)
                            {
                                item.subtasks.forEach(model => {
                                    if(model.taskId == element.taskId)
                                    {
                                        that.$refs.grid.setCellValue(model.taskId, 'result',element.result);
                                    }
                                })
                            }
                        })
                    })
                }
            });
        },
        dataBinding(dataSource) {
            let resdata = [];
            dataSource.forEach(element => {
                if(element._parentId == null)
                {
                    let master = {};
                    master.taskId = element.taskId;
                    master.netCode = element.netCode;
                    master.netType = element.netType;
                    master.fileName = element.fileName;
                    master.result = element.result;
                    master.createTime = element.createTime;
                    master.neId = element.neId;
                    master.subtasks = [];
                    resdata.push(master);
                }
                else{
                    let hasCont = false;
                    resdata.forEach(item => {
                        if(item.taskId == element._parentId)
                        {
                            hasCont = true;
                            item.subtasks.push(element);
                        }
                    })
                    //子数据存在而无父数据时列表展示（主要用于模糊搜索中的所有子任务的场景）
                    if(!hasCont)
                    {
                        resdata.push(element)
                    }
                }
            });
            this.data = resdata;
        },
        resultFormatter(field, data, column){
            return this.resultmap.get(data['result']);
        },
        click(){
            EventBus.$emit('patchdialogOpen');
            this.$refs.visiondialog.show();
            this.$refs.verPatchTask._getNeTreeData();
        },
        search(args) {
            if(this.input !== '')
            {
                const filterdata = dataSource.filter(item => this.filterMethod(item)).map(
                    item => {return item}
                );
                this.dataBinding(filterdata);
            }
            else{
                this.dataBinding(dataSource);
            }
        },
        //过滤方法
        filterMethod(item){
            const colmap = new Map([
                ['result', this.resultmap],
            ])
            const colarray = ['netCode', 'netType','fileName', 'progress', 'createTime'];
            let feildData1 = Array.from(colarray, x => {
                return item[x] === null ? '' : item[x] +'';
            });
            let feildData2 = Array.from([...colmap.keys()], x =>{
                var mapvalue = colmap.get(x).get(item[x]);
                return mapvalue === undefined ? '' : mapvalue;
            });
            let filres = false;
            [...feildData1, ...feildData2].forEach(item => {
                if(item.indexOf(this.input) > -1)
                {
                    filres = true;
                }
            })
            return filres;
        },
        submit(clickEvent) {
            if (clickEvent.keyCode === 13) {
                return;
            }
            this.$refs.verPatchTask.updateVersion(() => {
                    this.cancel();
                    this.request();
                });
        },
        cancel() {
            this.$refs.visiondialog.clear();
            this.$refs.visiondialog.close();
        },
        subscribeCallback(myData) {
            console.log('callback',myData)
            this.input = '';
            this.webSoketRequest();
        },
        getSelect() {
            const select = [];
            this.$refs.grid.getCheckedRecords().forEach(item => {
                if(item.level == 0)
                {
                    select.push(item);
                }
            })
            return select;
        },
        remove() {
            const taskIds = this.getSelect().map(x => x.taskId +'');
            if(taskIds.length == 0)
            {
                this.showToast('warning',`${this.$t("System.selectDelObj")}`);
                return;
            }
            this.$layer.confirm({
                msg: this.$t('LteUser.delConfirm'),
                btn2: {
                    msg: this.$t('System.confirm'),
                    func: () => {
                        this.$axios.post('/lte/ems/verupdate_new/delPatchVerAction', taskIds).then((response) => {
                            if(response.status == 200)
                            {
                                if(response.data.errorCode == 'SUCCESS')
                                {
                                    this.showToast('success', `${this.$t('Common.tips.success')}`);
                                }
                                else
                                {
                                    this.showToast('error',response.data.errorString);
                                }
                            }
                            this.request();
                        });
                    }
                },
                btn1: {
                    msg: this.$t('MCS.cancle')
                }
            });

        },
        rowDataBound(args){
            if(args.data['level'] === 1){
              args.row.getElementsByClassName('e-checkbox-wrapper')[0].classList.add('h-system-disablecheckbox')
            }
        },
        showToast(type, content)
        {
            EventBus.$emit('toast', {type: type, content: content});

        },
        exportLog(){
        this.$loading.showLoadding(this.$t("SubscriberIms.waitTip"));
          axios({
                    method: 'post',
                    url: '/lte/ems/verupdate_new/exportPatchLog',
                    data:{data:1},
                    // 二进制流文件，一定要设置成blob，默认是json
                    responseType: 'blob'
                  }).then(response => {
                    this.$loading.hideLoadding();
                    const link = document.createElement('a');
                    const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
                    let fileNames = response.headers['content-disposition'] //获取到Content-Disposition;filename
                    let regFileNames = fileNames.match(/=(.*)$/)[1]; //文件名称  截取=后面的文件名称

                    link.style.display = 'none';
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute("download", regFileNames);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                     this.$loading.hideLoadding();
                  });
        },
    }
}
</script>>
